import RelationshipPage from './RelationshipPage';

export default RelationshipPage;
